import type { TestResultsByControlIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetTestResultsByControlIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetTestResultsByControlIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetTestResultsByControlIdArgs = { controlId: string };

export const useGetTestResultsByControlId = createQueryHook<
  UseGetTestResultsByControlIdArgs,
  TestResultsByControlIdResponseRow[],
  GetTestResultsByControlIdQuery
>({
  trpcQueryOptions: (trpc, { controlId }) =>
    trpc.frontend.testResult.testResultsByControlId.queryOptions({
      controlId,
    }),
  mapTrpcDataToGraphQL: (data) => ({ test_result: data }),
  graphqlDocument: GetTestResultsByControlIdDocument,
  graphqlVariables: ({ controlId }) => ({ controlId }),
});
